import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_ANNOUNCEMENT, DELETE_ANNOUNCEMENT, ADD_ANNOUNCEMENT, EDIT_ANNOUNCEMENT } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetAnnouncementSuccess, GetAnnouncementFailure, DeleteAnnouncementSuccess, DeleteAnnouncementFailure, EditAnnouncementSuccess, EditAnnouncementFailure, AddAnnouncementSuccess, AddAnnouncementFailure } from "../Actions/AnnouncementAction.js";
import qs from "qs";

function getFormData(object) {
  const formData = qs.stringify(object);
  return formData;
}

const V1BE_API_URL = `${process.env.REACT_APP_API_URL}api/admin/announcements`;
function* EditAnnouncementRequest(actions) {
  const data = {
    description: actions.payload.description,
    start_date: actions.payload.start_date,
    end_date: actions.payload.end_date,
    id: actions.payload.id,
    remove_opt_outs: actions.payload.remove_opt_outs,
  };

  try {
    const res = yield axios.put(V1BE_API_URL, getFormData(data), {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(EditAnnouncementSuccess(res.data));
    } else yield put(EditAnnouncementFailure(res));
  } catch (e) {
    yield put(EditAnnouncementFailure(e));
  }
}

function* AddAnnouncementRequest(actions) {
  const data = {
    description: actions.payload.description,
    start_date: actions.payload.start_date,
    end_date: actions.payload.end_date,
  };
  try {
    const res = yield axios.post(V1BE_API_URL, getFormData(data), {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(AddAnnouncementSuccess(res.data));
    } else {
      yield put(AddAnnouncementFailure(res));
    }
  } catch (e) {
    yield put(AddAnnouncementFailure(e));
  }
}

function* GetAnnouncementRequest(actions) {
  try {
    const res = yield axios.get(V1BE_API_URL + `?sort_by=${actions.payload.sort_by}&sort_type=${actions.payload.sort_type}&search_key=${actions.payload.search_key}`, {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(GetAnnouncementSuccess(res.data));
    } else {
      yield put(GetAnnouncementFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetAnnouncementFailure(e));
  }
}

function* DeleteAnnouncementRequest(actions) {
  const data = {
    id: actions.payload,
  };

  try {
    delete axios.defaults.headers.common["Authorization"];
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/deleteannouncement`, getFormData(data), { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteAnnouncementSuccess(res.data));
    } else {
      yield put(DeleteAnnouncementFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteAnnouncementFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_ANNOUNCEMENT, GetAnnouncementRequest);
  yield takeLatest(DELETE_ANNOUNCEMENT, DeleteAnnouncementRequest);
  yield takeLatest(ADD_ANNOUNCEMENT, AddAnnouncementRequest);
  yield takeLatest(EDIT_ANNOUNCEMENT, EditAnnouncementRequest);
}

export default function* GetAnnouncementSaga() {
  yield all([actionWatcher()]);
}
